import { FC } from 'react';

export const TipHeadCell: FC<any> = ({ children }) => {
  return <div className="tip-container__th">{children}</div>;
};
